import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"280px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "出席者を変更")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fw600 ddgrey centered mt20" }, " この調整ページにログインできる出席者を変更します。出席者に加えることで、チャットの通知や前日のリマインドメールなどを受け取れるようになります。 ", -1)
const _hoisted_8 = { class: "mt10 w50 fl" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "text fl w50 mt20 pad20 llgreyBg rad20",
  style: {"color":"#696969"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  class: "posAb",
  style: {"width":"18px","top":"-5px","right":"-5px"}
}
const _hoisted_13 = ["src", "onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_AttendeeForm = _resolveComponent("AttendeeForm")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "EditAttendeesModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AttendeeForm, {
              onUpdate: _ctx.addAttendeeFromAddressBook,
              action: `new`
            }, null, 8, ["onUpdate"]),
            _hoisted_9
          ]),
          (_ctx.Util.isPresent(_ctx.attendees))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (mem, memindex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: memindex,
                      class: _normalizeClass(_ctx.isSP ? `fs11 posRe` : `fs11 fl mr2 posRe`)
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        (mem.role != 100)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                              width: "18",
                              height: "18",
                              class: "fr pointer",
                              onClick: ($event: any) => (_ctx.deleteAttendee(mem))
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_UserIcon, {
                        width: 48,
                        canEdit: false,
                        member: mem,
                        showTooltip: true,
                        class: "fl mr5 posRe mb5"
                      }, null, 8, ["member"])
                    ], 2))
                  }), 128))
                ]),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}